import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'
import { Head } from '#/components/head'


export default function OrganizationsError() {
  const { t } = useTranslation([ 'settings' ])
  const error = useRouteError()

  return (
    <div className="w-full">

      <Head title={t('organization_list.page_title')} />

      <ErrorBoundary error={error} />

    </div>
  )
}
